import type {
  BomVersion,
  BomVersionOperation,
  TechnicalPassportMaterial,
  TechnicalPassportRoute,
} from './types'

const STAGE_ALIASES: Array<[RegExp, string]> = [
  [/knit|to'q|вяз/i, 'knitting'],
  [/rosso|toe.?clos|мыс/i, 'rosso'],
  [/board|form|пар/i, 'boarding'],
  [/label|yorliq|этик/i, 'labeling'],
  [/pack|qadoq|упаков/i, 'packaging'],
]

function stageForOperation(operation: BomVersionOperation): string {
  const name = operation.operation_name.trim()
  return STAGE_ALIASES.find(([pattern]) => pattern.test(name))?.[1] ?? 'finishing'
}

export function bomToPassportRoutes(bom: BomVersion): TechnicalPassportRoute[] {
  return bom.operations.map((operation) => ({
    operation_id: operation.operation_reference_id ?? undefined,
    operation_name: operation.operation_name,
    department_agent_id: operation.department_agent_id ?? undefined,
    workstation_agent_id: operation.equipment_reference_id ?? undefined,
    workstation_name: operation.equipment_name ?? undefined,
    standard_time_minutes: operation.duration_minutes,
    qc_required: false,
    sort_order: operation.operation_sequence,
  }))
}

export function bomToPassportMaterials(
  bom: BomVersion,
): TechnicalPassportMaterial[] {
  return bom.operations.flatMap((operation) =>
    operation.materials.map((material) => ({
      stage_code: stageForOperation(operation),
      material_product_id: material.material_id,
      material_name_snapshot: material.material_name,
      consumption_per_pair: material.quantity,
      waste_percent: material.loss_percentage,
      uom: material.material_unit,
      sort_order: operation.operation_sequence,
    })),
  )
}

export function applyBomToPassport(
  bom: BomVersion,
): { routes: TechnicalPassportRoute[]; materials: TechnicalPassportMaterial[] } {
  return {
    routes: bomToPassportRoutes(bom),
    materials: bomToPassportMaterials(bom),
  }
}
